import axios from '@/axios.js'

let phoneCodesPromise = null
let platformsAdultPromise = null
let platformsPromise = null

export async function loadHarmonyData(slug, userId = 0) {
  const response = await axios.get(`/site/${slug}`, {
    params: { user_id: userId }
  })
  const site = response.data.site
  return {
    harmony: site,
    visits: site.visits_count,
    likes: site.likes_count,
    isLiked: site.user_has_liked,
    isOwner: site.owner,
    isFollowed: site.user_has_followed,
    monetize: response.data.monetize,
    settings: JSON.parse(site.site_settings.setting),
    translatedText: response.data.translatedText,
    translatedSelectText: response.data.translatedSelectText,
    translatedDescription: response.data.translatedDescription,
    translatedFooterText: response.data.translatedFooterText,
  }
}

export async function getPhoneCodesCached() {
  if (!phoneCodesPromise) {
    phoneCodesPromise = axios.get('/get-phone-codes').then(response => {
      return response.data.map(code => {
        code.flag = `https://flagcdn.com/24x18/${code.code.toLowerCase()}.png`
        return code
      })
    }).catch(err => {
      phoneCodesPromise = null
      throw err
    })
  }
  return phoneCodesPromise
}

export async function getPlatformsAdultCached() {
  if (!platformsAdultPromise) {
    platformsAdultPromise = axios.get('get-platforms-adult').then(response => {
      return response.data
    }).catch(err => {
      platformsAdultPromise = null
      throw err
    })
  }
  return platformsAdultPromise
}

export async function getPlatformsCached() {
  if (!platformsPromise) {
    platformsPromise = axios.get('get-platforms').then(response => {
      return response.data
    }).catch(err => {
      platformsPromise = null
      throw err
    })
  }
  return platformsPromise
}
